import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-flex tw-justify-end tw-bg-gray-50" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times tw-text-gray-500",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "tw-h-full tw-grid baseGrid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      appear: "",
      class: "tw-block md:tw-hidden tw-fixed tw-w-full tw-overflow-y-auto tw-z-20 tw-card tw-shadow-lg tw-bg-gray-50 tw-pb-1",
      style: {"max-height":"400px","width":"calc(100vw - 10px)","left":"4px","bottom":"4px"},
      "enter-active-class": "animate__animated animate__slideInUp animate__faster",
      "leave-active-class": "animate__animated animate__slideOutDown animate__faster"
    }, {
      default: _withCtx(() => [
        (_ctx.show && _ctx.$slots['sidebar'])
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
            () => {
              _ctx.show = false;
            }
          )
                }, _hoisted_4)
              ]),
              _renderSlot(_ctx.$slots, "sidebar")
            ])), [
              [_directive_click_outside, 
        () => {
          _ctx.show = false;
        }
      ]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["tw-hidden md:tw-block tw-h-full tw-overflow-y-auto tw-bg-gray-50", {
        'tw-p-4 tw-pr-0': _ctx.$route.fullPath !== '/private/launcher' && _ctx.$route.fullPath !== '/private/notifications-center',
      }])
      }, [
        _renderSlot(_ctx.$slots, "sidebar")
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tw-bg-gray-50", [
        _ctx.$route.fullPath === '/private/launcher' ? '' : _ctx.$route.fullPath === '/private/notifications-center' ? 'tw-overflow-y-auto' : 'tw-overflow-y-auto tw-p-4',
      ]])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ])
  ], 64))
}